// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Download from "@store/Library/Components/Toolkit/Icons/Download";
import { fixDate } from "@store/Framework/Common/Utilities/reportingUtils";
import { DataTableData } from "@store/Library/Components/Reporting/ApiDataTable/ReportDataTable";
// eslint-disable-next-line spire/fenced-imports
import getColor from "@insite/mobius/utilities/getColor";
import { fixSheetName } from "@store/Framework/Common/Utilities/excelExportFunctions";
import Button from "@store/MobiusOverrides/Button/Button";
import React from "react";
import styled from "styled-components";
import xlsx from "xlsx";

const ButtonReport = styled(Button)`
    && {
        font-size: 0.875rem !important;
        font-weight: 400;
        min-height: unset !important;
        padding: 0.4rem 0.625rem !important;
        margin-right: 0.25rem;
        margin-left: 0.25rem;
        & * {
            font-size: 0.875rem !important;
        }
    }
`;

const ButtonReportOutline = styled(ButtonReport)`
    && {
        background-color: transparent;
        border: 1px solid ${getColor("primary.main")};
        color: ${getColor("primary.main")};
        & :hover {
            border: 1px solid ${getColor("text.link")};
            color: ${getColor("text.linkHover")};
        }
    }
`;

const ButtonReportOutlineSecondary = styled(ButtonReportOutline)`
    && {
        font-weight: 600;
        border: 2px solid ${getColor("text.link")};
        color: ${getColor("text.link")};
        & * {
            color: ${getColor("text.link")};
        }
        & :hover {
            border: 2px solid ${getColor("primary.main")};
            color: ${getColor("primary.main")};
            & * {
                color: ${getColor("primary.main")};
            }
        }
        & svg {
            height: 20px;
            width: 20px;
            margin-left: 3px;
        }
        & :disabled {
            opacity: 0.5;
        }
    }
`;

export const createSheet = (tableData: DataTableData<any>) => {
    const workSheetArray: (string | number | Date | JSX.Element)[][] = [];
    const { headers, data, dataKeys, title } = tableData;
    workSheetArray.push(headers);
    data.forEach(row => {
        workSheetArray.push(
            // @ts-ignore
            dataKeys?.map((key: string | number | symbol) => {
                if (key.toString().toLowerCase().includes("date") || String(row[key]).includes("T")) {
                    return fixDate(row[key]);
                }
                return row[key];
            }),
        );
    });
    const sheet = xlsx.utils.aoa_to_sheet(workSheetArray);
    const widths = Array(headers.length)
        .fill("")
        .map(() => {
            return { width: 20 };
        });
    sheet["!cols"] = widths;
    return sheet;
};
interface Props {
    excelData?: DataTableData<any> | DataTableData<any>[];
    callback?: () => void;
    disabled: boolean;
    isLoading?: boolean;
}
const ButtonExportFile: React.FC<Props> = ({ excelData, callback, disabled, isLoading = false }) => {
    const handleSheetExport = () => {
        if (!excelData) {
            return;
        }
        const book = xlsx.utils.book_new();
        if (Array.isArray(excelData)) {
            excelData.forEach(tableData => {
                const sheet = createSheet(tableData);
                const fixedSheetTitle = fixSheetName(tableData.title);

                xlsx.utils.book_append_sheet(book, sheet, fixedSheetTitle);
            });
        } else {
            const sheet = createSheet(excelData);
            const fixedSheetTitle = fixSheetName(excelData.title);
            xlsx.utils.book_append_sheet(book, sheet, fixedSheetTitle);
        }
        const title = Array.isArray(excelData)
            ? excelData[0]?.dataSummaryTitle?.slice(0, 31)
            : excelData.title.slice(0, 31);
        xlsx.writeFile(book, `${title}.xlsx`);
    };

    return (
        <>
            <Button
                data-test-selector="generateExcelFile_generateExcelFile"
                disabled={disabled}
                onClick={callback || handleSheetExport}
                variant="tertiary"
                icon={{ src: Download }}
                isLoading={isLoading}
            >
                {translate("Export Excel")}
            </Button>
        </>
    );
};
export default ButtonExportFile;
